import { render, staticRenderFns } from "./card-container.vue?vue&type=template&id=364bbffb&scoped=true&"
import script from "./card-container.vue?vue&type=script&setup=true&lang=ts&"
export * from "./card-container.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./card-container.vue?vue&type=style&index=0&id=364bbffb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364bbffb",
  null
  
)

export default component.exports